import { PermissionService } from 'services/PermissionService';
import { Permissions } from '../../../permissions';
import { createInicident } from 'services/CeberusApiService';
import { RouteComponentProps, Link } from 'react-router-dom';
import './IncidentCreationPage.scss';
import { Layout, Card, Button, Form, Input, Select, TreeSelect, Popconfirm, Icon } from 'antd';
import { AppSettings } from '../../../appSettings';
import { Incident } from 'models/Blip/Incident';
import { IncidentRequest } from 'models/request/IncidentRequest';
import { Component } from 'react';
import { BaseRequest } from 'models/request/BaseRequest';
import React from 'react';
import { PushNotification } from 'utils/PushNotification';

type CreatePageProps = BaseRequest & RouteComponentProps;

const INVALID = 'Some fields are invalid, check values and try again';
const ERROR = 'Incident creation failed';
const SUCESSFULL = 'Incident created successfully';
const STATUS_PAGE = '/statuspage';
const CLUSTER_COMPONENTS = 'CLUSTER_COMPONENTS';

export class IncidentCreationPage extends Component<CreatePageProps> {
  
  state = {
    incidentName: '',
    incidentStatus: '',
    incidentMessage: '',
    componentAffected: [],
    componentStatus: '',
    componentName: [],
    componentsStatus: [],
    dataComponents: [],
    isLoading: false,
    componentGroup: [],
    optionsValues: [],
    canCreateIncident: PermissionService.hasPermission(Permissions.Application_StatusPage__Edit)
  }

  async componentDidMount() {
    await this.onBuild();
  }

  onChange = (checked, param) => {
    const { optionsValues } = this.state;
    optionsValues[param] = checked;
    this.setState(optionsValues);
  };

  onBuild = async () => {
    await this.verifyListComponents();    
    this.setState({
      isLoading: false
    });
  }

  handleSubmit = async (e) => {
    this.setState({
      isLoading: true
    });
    if (this.verifyIncidentFields()) {
      PushNotification.error(INVALID);
    } else {
      try {
        const incident = new Incident(null,
          this.state.incidentName,
          this.state.incidentStatus,
          true,
          true,
          true,
          true,
          {},
          true,
          this.state.incidentMessage,
          {},
          this.state.componentAffected
        );
        const incidentRequest = new IncidentRequest(incident);
        await createInicident(incidentRequest);
        PushNotification.success(SUCESSFULL);
        e.preventDefault();
        this.props.history.push(STATUS_PAGE);
      }
      catch (error) {
        PushNotification.error(ERROR);
      }
    }
    this.setState({
      isLoading: false
    });
  }

  async verifyListComponents(){
    const clusteComponents = await AppSettings.get(CLUSTER_COMPONENTS); 
    this.setState({ dataComponents: clusteComponents });
  }

  verifyIncidentFields() {
    return this.state.incidentMessage == '' || this.state.incidentStatus == '' || this.state.incidentName == '' || this.state.componentAffected.length == 0;
  }

  handleincidentNameChange = e => {
    this.setState({
      incidentName: e.target.value
    });
  }

  handleincidentStatusChange = (value) => {
    this.setState({
      incidentStatus: value
    });
  }

  handlecomponentStatusChange = (value) => {
    this.setState({
      componentStatus: value
    });
  }

  handleincidentMessageChange = e => {
    this.setState({
      incidentMessage: e.target.value
    });
  }

  handlecomponentAffectedChange = async (value) => {
    this.setState({
      componentAffected: value
    });
  } 

  render() {

    return (
      <>
        <div className='ant-btn tc ant-btn-primary ant-btn-lg'>
          <Button type="primary">
            <Link to={STATUS_PAGE}>
              <Icon type="left" />
              Return to incidents  
            </Link>
          </Button>
        </div>
        <div>
          <Layout.Content className="body-incidents">
            <Card title="Create Incident" className="mb3">
              <Form name="basic">
                <Form.Item label="Incident Name" required={true} >
                  <Input 
                  value={this.state.incidentName}
                  onChange={this.handleincidentNameChange} 
                  allowClear />
                </Form.Item>
                <Form.Item label="Incident Status" required={true}>
                  <Select
                    placeholder="Select incident status"
                    allowClear
                    value={this.state.incidentStatus} onChange={this.handleincidentStatusChange} >
                    <Select.Option value="investigating">Investigating</Select.Option>
                    <Select.Option value="identified">Identified</Select.Option>
                    <Select.Option value="monitoring">Monitoring</Select.Option>
                    <Select.Option value="resolved">Resolved</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item label="Message" required={true}>
                  <Input.TextArea
                    maxLength={1000}
                    value={this.state.incidentMessage}
                    onChange={this.handleincidentMessageChange}
                    allowClear
                  />
                  </Form.Item>
                <Form.Item label="Components affected" required={true}>
                  <TreeSelect
                    treeData={this.state.dataComponents}
                    showSearch
                    style={{
                      width: '100%',
                    }}
                    dropdownStyle={{
                      maxHeight: 400,
                      overflow: 'auto',
                    }}
                    placeholder="Please select"
                    allowClear
                    multiple                    
                    onChange={this.handlecomponentAffectedChange}
                  >
                  </TreeSelect>
                </Form.Item>
                <Form.Item>
                  <Form.Item>
                    <Popconfirm
                      title="Do you really want to log this incident on the clusters status page ?"
                      onConfirm={this.handleSubmit}>
                      <Button type="primary" htmlType="button" >
                        Create
                      </Button>
                    </Popconfirm>
                  </Form.Item>
                </Form.Item>
              </Form>
            </Card>
          </Layout.Content>
        </div>
        <Layout.Content style={{ width: 400, margin: '0 auto' }}>
        </Layout.Content>
      </>
    );
  }
}